/**
 * A need-by is a *day*, not an instant.
 *
 * It is stored as midnight UTC, so rendering it with the browser's timezone
 * puts "20 November" on screen as 19 November for anybody west of Greenwich —
 * which is everybody here. A build order dated a day early is the kind of wrong
 * that nobody reports as a bug; they just quietly stop trusting the dates.
 *
 * Instants that genuinely are moments — when an execution opened, when a photo
 * was taken — are *not* this, and stay local: "closed at 14:32" means the wall
 * clock of whoever closed it.
 */
export function formatDay(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { timeZone: 'UTC' })
}

/** Whole days from now until a day, positive for the future. Rounded in UTC. */
export function daysUntil(iso: string, now: number = Date.now()): number {
  return Math.round((Date.parse(iso) - now) / 86_400_000)
}
